import {
  SET_ADDRESSES,
  SET_BILLING_ADDRESSES,
  ADD_ADDRESS,
  DELETE_ADDRESS,
  EDIT_ADDRESS,
  HAVE_MAIN_ADDRESS,
  ADD_BILLING_ADDRESS,
  DELETE_BILLING_ADDRESS,
  EDIT_BILLING_ADDRESS,
} from '../types/AddressesTypes';
import {
  createAddressFormBody,
  firstAddressBody,
} from '../../helpers/addresses/AddressesHelper';
import {
  callCreateUserAddress,
  callDeleteUserAddress,
  callEditUserAddress,
} from '../../services/AddressesService';
import { updateUserProfile } from '../../services/ProfileService';
import { setUserFirstAddress } from '../actions/ProfileActions';
import { successMessage, errorMessage } from './FlashActions';

export const setAddresses = (addresses) => {
  return {
    type: SET_ADDRESSES,
    addresses,
  };
};

export const setBillingAddresses = (addresses) => {
  return {
    type: SET_BILLING_ADDRESSES,
    addresses,
  };
};

export const addNewAddress = (address) => {
  return {
    type: ADD_ADDRESS,
    address,
  };
};

export const addNewBillingAddress = (address) => {
  return {
    type: ADD_BILLING_ADDRESS,
    address,
  };
};

export const deleteAddress = (nickname) => {
  return {
    type: DELETE_ADDRESS,
    nickname,
  };
};

export const deleteBillingAddress = (nickname) => {
  return {
    type: DELETE_BILLING_ADDRESS,
    nickname,
  };
};

export const editAddress = (address) => {
  return {
    type: EDIT_ADDRESS,
    address,
  };
};

export const editBillingAddress = (address) => {
  return {
    type: EDIT_BILLING_ADDRESS,
    address,
  };
};

export const haveMainAddress = (have) => {
  return {
    type: HAVE_MAIN_ADDRESS,
    have,
  };
};

export const createNewAddress = (state, isPrimary, isBilling) => {
  return async (dispatch, getState) => {
    const { profile } = getState().profileReducer;
    const { addressLine } = profile;
    try {
      if (!addressLine) {
        return await createFirstAddress(dispatch, state, profile, isPrimary);
      } else {
        return await createAnotherAddress(
          dispatch,
          state,
          profile,
          isPrimary,
          isBilling,
        );
      }
    } catch (err) {
      dispatch(errorMessage('Hubo un problema al crear tu dirección'));
      return false;
    }
  };
};

const createFirstAddress = async (dispatch, state, profile, isPrimary) => {
  const data = firstAddressBody(state, profile, isPrimary);
  const res = await updateUserProfile(profile.userId, data);
  if (res.status === 201) {
    if (isPrimary) dispatch(haveMainAddress(true));
    dispatch(addNewAddress(data));
    dispatch(setUserFirstAddress(data));
    dispatch(successMessage('Tu dirección fue creada correctamente'));
    return true;
  } else {
    dispatch(errorMessage('Hubo un problema al crear tu dirección'));
    return false;
  }
};

const createAnotherAddress = async (
  dispatch,
  state,
  profile,
  isPrimary,
  isBilling,
) => {
  const { userId, email1 } = profile;
  const body = createAddressFormBody(state, isPrimary, isBilling, email1);
  const res = await callCreateUserAddress(body, userId);
  if (res.status !== 200) {
    dispatch(errorMessage('Hubo un problema al crear tu nueva dirección'));
    return false;
  } else {
    if (isPrimary) dispatch(haveMainAddress(true));
    if (isBilling) dispatch(addNewBillingAddress(body));
    else dispatch(addNewAddress(body));
    dispatch(successMessage('Tu dirección fue creada correctamente'));
    return true;
  }
};

export const editExistingAddress = (
  state,
  isPrimary,
  isBilling,
  actualIsPrimary,
) => {
  return async (dispatch, getState) => {
    const { userId, email1, nickName } = getState().profileReducer.profile;
    try {
      const body = createAddressFormBody(state, isPrimary, isBilling, email1);
      const res = await callEditUserAddress(body, userId);
      if (res.status !== 201) {
        dispatch(errorMessage('Hubo un problema al editar tu nueva dirección'));
        return false;
      } else {
        if (isPrimary) dispatch(haveMainAddress(true));
        else {
          if (actualIsPrimary === 'true') dispatch(haveMainAddress(false));
        }
        if (body.nickName === nickName) body.nickName = 'Dirección Inicial';
        if (isBilling) dispatch(editBillingAddress(body));
        else dispatch(editAddress(body));
        dispatch(successMessage('Tu dirección fue editada correctamente'));
        return true;
      }
    } catch (err) {
      dispatch(errorMessage('Hubo un problema al editar tu dirección'));
      return false;
    }
  };
};

export const deleteAddressRequest = (nickname, primary, isBilling) => {
  return async (dispatch, getState) => {
    try {
      const userId = getState().profileReducer.profile.userId;
      const res = await callDeleteUserAddress(userId, nickname);
      if (res.status !== 200) {
        dispatch(errorMessage('Hubo un problema al eliminar tu dirección'));
        return false;
      } else {
        if (primary === 'true') dispatch(haveMainAddress(false));
        if (isBilling) dispatch(deleteBillingAddress(nickname));
        else dispatch(deleteAddress(nickname));
        dispatch(successMessage('Tu dirección fue eliminada correctamente'));
        return true;
      }
    } catch (err) {
      dispatch(errorMessage('Hubo un problema al eliminar tu dirección'));
      return false;
    }
  };
};
